 
export enum AuthenticationSource {
  PUBLIC_SITE = 'WEB',
  ADMIN_PORTAL = 'ADMIN'
}
